import React from "react"
import { Link } from "gatsby-theme-material-ui"
export default function Phone() {
  return <Link to="tel:+61413394528">0413 394 528</Link>
}
